import FirebaseService from './firebase';
// import sdk from '@/lib/sdk';
// import report from '@wps/wps_client_api/report';
import report from '@/lib/client-api/report'
export const firebase = new FirebaseService();
const collect = (event, data) => {
  report.dataWarehouseSend(event, data);
  firebase.collect(event, data);
};
export default collect;


// WEBPACK FOOTER //
// ./src/utils/report.js